module.exports = __webpack_public_path__ + "static/media/ex.51633b72.gif";